export { default } from './FavoriteWindow';
